import apiClient from '@/api/apiClient.js';
import { getPatPatientsId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    recordDerivations: [],
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    recordDerivations(state) {
      return state.recordDerivations;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertDerivations(state, recordDerivations) {
      state.recordDerivations = recordDerivations;
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.patRecordBSchema();
        const schema = res.data;

        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadRecordDerivations({ commit }) {
      try {
        const id = getPatPatientsId();
        let res = await apiClient.recordDerivations(id);
        let recordDerivations = res.data.data;
        commit('insertDerivations', recordDerivations);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async saveDerivations({ commit }, payload) {
      try {
        const id = payload.id;
        const model = {};
        await apiClient.saveRecordDerivations(id, model);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error guardando');
        commit('saveError');
        throw error;
      }
    },
  },
};
